import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOMeta from '../components/SEOMeta';

function ContactPage() {
  const contactJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact Hercles Global',
    url: 'https://herclesglobal.com/contact',
    mainEntity: {
      '@type': 'ElectronicsStore',
      name: 'Hercles Global',
      url: 'https://herclesglobal.com',
      telephone: '+254724474097',
      email: 'info@herclesglobal.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Nairobi',
        addressCountry: 'KE',
      },
    },
  };

  return (
    <div className="about-page">
      <SEOMeta
        title="Contact Us"
        description="Contact Hercles Global in Nairobi, Kenya for laptops, phones, accessories, delivery support and product enquiries. Call, WhatsApp or email our team."
        canonical="/contact"
        jsonLd={contactJsonLd}
      />
      <Header />
      <main className="about-inner">
        <section className="about-hero">
          <h1>Contact Hercles Global</h1>
          <p>Reach our Nairobi team for product advice, order support, delivery details, and warranty questions.</p>
        </section>

        <section className="about-section contact-grid">
          <div>
            <h2>Talk To Us</h2>
            <p><strong>Phone/WhatsApp:</strong> <a href="tel:+254724474097">+254 724 474097</a></p>
            <p><strong>Email:</strong> <a href="mailto:info@herclesglobal.com">info@herclesglobal.com</a></p>
            <p><strong>Location:</strong> Nairobi, Kenya</p>
            <p><strong>Hours:</strong> Monday to Saturday, 8 AM - 8 PM</p>
          </div>

          <div>
            <h2>What We Can Help With</h2>
            <ul>
              <li>Product availability and recommendations</li>
              <li>Delivery timelines across Nairobi and Kenya</li>
              <li>Order, payment, and checkout support</li>
              <li>Returns, warranty, and after-sales service</li>
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default ContactPage;
